<template>
	<div class="summary__body-card">
		<div class="summary__body-card-icon" :class="[ 'service-icon' , iconName ]"></div>
		<div class="summary__body-card-name">{{serviceName}}</div>
		<div class="summary__body-card-total">$ {{serviceTotal}}</div>
	</div>
</template>

<script>
export default {
	name: "UsageSummarySmallCard",
	props: ["service"],
	computed: {
		iconName: function () {
			return this.service.service.name.toLowerCase() + "-icon";
		},
		serviceName: function () {
			return this.service.service.name;
		},
		serviceTotal: function () {
			return this.service.totalCents / 100;
		},
	},
};
</script>

<style>
.light .summary__body-card {
	border: 1px solid #d8d8d8;
}
.dark .summary__body-card {
	border: 1px solid #4d4b4b;
}
.light .summary__body-card-name {
	color: #C78500;
}
.dark .summary__body-card-name {
	color: #ffb536;
}
.light .summary__body-card-total {
	color: #212529;
}
.dark .summary__body-card-total {
	color: #fafafa;
}
.summary__body-card {
	display: flex;
	align-items: center;
	border-radius: 2px;
	padding-left: 15px;
	padding-right: 15px;
}
.summary__body-card-icon {
	width: 20px;
	height: 20px;
	margin-right: 10px;
}
.summary__body-card-name {
	font-family: Corbel, sans-serif;
	font-size: 14px;
}
.summary__body-card-total {
	margin-left: auto;
}
</style>